import React, { useState, useEffect, useRef } from 'react';
import DashboardSideNav from '../components/DashboardSideNav';
import DashboardBottomNav from '../components/DashboardBottomNav';
import FeedbackModal from '../components/FeedbackModal';
import NotetakerModal from '../components/DashboardNotetakerModal';
import logoIcon from './../assets/images/logo-black.svg';
import { Icon } from "@iconify/react";

type LayoutProps = {
    children: React.ReactNode;
};

const DashboardLayout: React.FC<LayoutProps> = ({ children }) => {
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
    const [isNoteTakerModalOpen, setIsNoteTakerModalOpen] = useState(false)
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [isLaptop, setIsLaptop] = useState(false);
    const hamburgerRef = useRef<HTMLButtonElement>(null);

    const handleOpenFeedbackModal = () => setIsFeedbackModalOpen(true);
    const handleCloseFeedbackModal = () => setIsFeedbackModalOpen(false);
    // Function to toggle the sidenav
    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };



    // Check for screen size changes to open/close sidenav automatically
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setIsLaptop(true);
                setIsNavOpen(false); // Ensure the sidenav is always open on laptop screens
            } else {
                setIsLaptop(false);
            }
        };

        // Initial check and listener for window resize
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <main className="flex flex-col lg:flex-row lg:h-screen lg:overflow-hidden custom-scrollbar pb-16 lg:pb-0">
            <div className="hidden md:flex md:items-center md:fixed top-0 left-0 w-full bg-white py-5 lg:hidden z-30">
                <button
                    ref={hamburgerRef}
                    className="absolute left-14 text-white text-3xl focus:outline-none z-30"
                    onClick={toggleNav}
                >
                    <Icon icon="octicon:three-bars-24" color="#222222" className="text-[#222222] h-6 w-6" />
                </button>
                <div className="w-[77.96px] h-[18.39px] mx-auto border-b border-gray-200 flex items-center justify-center">
                    <img src={logoIcon} alt="company logo" className="h-10 mr-3" />
                </div>
            </div>

            <DashboardSideNav onOpenFeedbackModal={handleOpenFeedbackModal} onOpenNotetakerModal={() => setIsNoteTakerModalOpen(true)} isLaptop={isLaptop} isNavOpen={isNavOpen} toggleNav={toggleNav} hamburgerRef={hamburgerRef} />
            <div className="relative flex-1 flex flex-col pt-6 lg:pt-6 pb-8 md:pb-3 md:pt-24 lg:pl-4 px-3 lg:px-0 min-h-[90vh]">
                {children}
            </div>
            {isFeedbackModalOpen && (
                <FeedbackModal onClose={handleCloseFeedbackModal} />
            )}

            {isNoteTakerModalOpen && (
                <NotetakerModal
                    onClose={() => setIsNoteTakerModalOpen(false)}
                />
            )}
            <DashboardBottomNav />


        </main>
    );
};

export default DashboardLayout;
